// extracted by mini-css-extract-plugin
module.exports = {"root":"az_A7","disabled":"az_B7","edgeStart":"az_C7","edgeEnd":"az_D7","colorInherit":"az_E7","colorPrimary":"az_F7","colorSecondary":"az_G7","sizeSmall":"az_H7","label":"az_I7"};